// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "b7e5eff152eb0febbfae3e8a735763023aac9455/" + chunkId + ".js";
};